import React from 'react';
import PropTypes from 'prop-types';

import { FormItem, TextInput } from '@cw-ui/form-components';

import { FIELD_TYPES } from '../../../constants';
import { FIELD_FORM_CONTROL_CLASS, SINGLE_LINE_INPUT_SX } from '../field-form-control-styles';

const TextField = ({ field, value, onChange, onBlur, helperText, errorText, disabled = false }) => {
  const maxLength = field.validation?.maxLength;
  const count = maxLength ? `${(value ?? '').length}/${maxLength}` : undefined;
  const hasError = Boolean(errorText);

  return (
    <FormItem
      id={field.id}
      labelText={field.label}
      labelProps={{ required: field.required, error: hasError }}
      shrink
      size="medium"
      fullWidth
      className={FIELD_FORM_CONTROL_CLASS}
    >
      <TextInput
        id={field.id}
        type={field.type === FIELD_TYPES.EMAIL ? 'email' : 'text'}
        placeholder={field.placeholder}
        value={value ?? ''}
        onChange={event => onChange(event.target.value)}
        onBlur={onBlur}
        count={count}
        error={hasError}
        helperText={errorText ?? helperText}
        disabled={disabled}
        inputProps={maxLength ? { maxLength } : undefined}
        sx={SINGLE_LINE_INPUT_SX}
      />
    </FormItem>
  );
};

TextField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    validation: PropTypes.shape({ maxLength: PropTypes.number })
  }).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  helperText: PropTypes.string,
  errorText: PropTypes.string,
  disabled: PropTypes.bool
};

export default TextField;
